import { TranslateService } from '@ngx-translate/core';
import {
    ColumnModel,
    CompositeModel,
    CustomInjector,
    HistoryModel,
    NotificationModel,
    TableModel,
    TableModelOptions,
} from '@evorait/pace-core';

export enum HISTORY_LONG_TEXT {
    HIST = 'HIST',
    HREP = 'HREP',
    HMAT = 'HMAT',
}

export default class EquipmentHistoryModel extends CompositeModel {
    public tableModel: TableModel<HistoryModel>;
    public equipmentHistoryList: HistoryModel[];

    public historyModel: HistoryModel;
    public constructor(public notificationModel: NotificationModel) {
        super('EquipmentHistoryModel');

        const injector = CustomInjector.getInjector();
        const translate = injector.get(TranslateService);

        const columns: ColumnModel[] = [];
        columns.push(
            new ColumnModel(
                <string>translate.instant('NOTIFICATION_DETAIL_EQUIPMENTS_HISTORY_NOTIFICATION_ID'),
                'notificationNo.value',
            ),
        );
        columns.push(
            new ColumnModel(
                <string>translate.instant('NOTIFICATION_DETAIL_EQUIPMENTS_HISTORY_DATE'),
                'createdDate.value',
            ),
        );
        const tableOptions = new TableModelOptions({ columns });

        this.tableModel = new TableModel<HistoryModel>(notificationModel.historySet, tableOptions);
        this.historyModel = this.tableModel.selectedRow;
        this.equipmentHistoryList = notificationModel.historySet;
    }
}
